<div [formGroup]="formGroup">
  <mat-form-field class="full-width">
    <textarea  matInput
            [placeholder]="titulo"
            [name]="controlName"
            [formControlName]="controlName">
    </textarea>
    <mat-error *ngIf="validacao.hasErrorValidar(formControl, 'required')">Campo obrigatório</mat-error>
    <mat-error *ngIf="validacao.hasErrorValidar(formControl, 'minlength')">
      Campo precisa ter no mínimo {{validacao.lengthValidar(formControl, 'minlength')}} caracteres
    </mat-error>
    <mat-error *ngIf="validacao.hasErrorValidar(formControl, 'maxlength')">
      Campo pode ter no máximo {{validacao.lengthValidar(formControl, 'maxlength')}} caracteres
    </mat-error>
  </mat-form-field>
</div>
